import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ConnectionMeter from './ConnectionMeter';
import LocalVideoContainer from './LocalVideoContainer';
import RemoteVideoContainer from './RemoteVideoContainer';
import VideoLayoutBackgroundManager from '../VideoLayoutBackgroundManager';

import theme from './VideoConference.scss';

const propTypes = {
  switched: PropTypes.bool,
  isNeedToShowLocalVideo: PropTypes.bool,
  isMCU: PropTypes.bool,
};

const defaultProps = {
  switched: false,
  isNeedToShowLocalVideo: false,
  isMCU: true,
};

const Conference = ({ switched, isNeedToShowLocalVideo, isMCU }) => (
  <div className={ theme.root }>
    <ConnectionMeter />
    <RemoteVideoContainer placeholder={ VideoLayoutBackgroundManager } />
    <If condition={ isNeedToShowLocalVideo && !isMCU }>
      <LocalVideoContainer className={ classnames(theme.localVideoContainer, { [theme.switched]: switched }) } />
    </If>
  </div>
);

Conference.propTypes = propTypes;
Conference.defaultProps = defaultProps;


export default Conference;
